import React from 'react';
import { GetStaticProps, NextPage } from 'next';
import { useTranslations } from 'next-intl';

import { BlokMainCards } from 'modules/blok-test';
import { globalConst } from 'modules/global';

import { NextHead } from 'components';

const Index: NextPage = () => {
  const t = useTranslations();

  const cardsData = [
    {
      imageWidth: 350,
      imageHeight: 350,
      bgColor: 'bg-white',
      hasHoverEffect: false,
      text: t('home.banner.AvtoTest'),
      url: globalConst.pageNames.AUTO_TEST,
      image: '/images/auto-test-block.webp',
      extraSection: <div className="mt-1 rounded-md bg-green-500 px-2 text-white">2025</div>
    },
    {
      bgColor: 'bg-white',
      hoverColor: '#37BEF1',
      hasHoverEffect: false,
      image: '/images/dtm-bg.webp',
      text: t('home.banner.DTMtest'),
      url: globalConst.pageNames.DTM,
      extraSection: <div className="mt-1 rounded-md bg-blue-600 px-2 text-white">2025</div>
    },
    {
      bgColor: 'bg-white',
      hoverColor: '#FFA594',
      hasHoverEffect: false,
      text: t('virtual_imtihon'),
      image: '/images/vertual-bg.webp',
      url: globalConst.pageNames.VIRTUAL
    },
    {
      bgColor: 'bg-white',
      hasHoverEffect: false,
      color: 'text-blue-800',
      text: t('milliy_sertifikat_testi'),
      url: globalConst.pageNames.NATIONAL_CERTIFICATE,
      image: '/images/national-certificate.webp',
      extraSection: <div className="mt-1 rounded-md bg-blue-600 px-2 text-white">2025</div>
    }
  ];

  return (
    <>
      <NextHead title={t('meta.blok_test.title')} description={t('meta.blok_test.description')} />

      <div className="max-w-screen mx-auto my-7 h-full p-4 md:min-h-screen">
        <h1 className="mb-6 text-center text-2xl font-bold md:text-left">{t('nav.blok_test')}</h1>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-2">
          {cardsData.map((item, index) => (
            <BlokMainCards
              isHorizontal
              // eslint-disable-next-line react/no-array-index-key
              key={index + 1}
              url={item.url}
              text={item.text}
              color={item.color}
              image={item.image}
              bgColor={item.bgColor}
              hoverColor={item.hoverColor}
              imageWidth={item.imageWidth}
              imageHeight={item.imageHeight}
              extraSection={item.extraSection}
              hasHoverEffect={item.hasHoverEffect}
            />
          ))}
        </div>
      </div>
    </>
  );
};

export default Index;

export const getStaticProps: GetStaticProps = async ({ locale }) => ({
  props: {
    messages: (await import(`../messages/${locale}.json`)).default
  }
});
